/**
 * Created by Kotkin on 18.07.17.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { authConnect, UserProp } from 'auth';
import Button from 'components/button';

import CardInfoModal from './card-info-modal';

import 'styles/base/subsys/card-info/_card-info.scss';

const bemClasses = new Bem('cardInfo');

@authConnect()
export default class CardInfo extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    userPhoto: PropTypes.shape({}),
    contentPhoto: PropTypes.shape({}),
    userName: PropTypes.string,
    userId: PropTypes.number,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.auth.authenticated && state.openModalAfterLogin) {
      return {
        openModalAfterLogin: false,
        opened: state.opened
      };
    }
    return null;
  }

  constructor(props, ctx) {
    super(props, ctx);
    this.openModalInfo = this.openModalInfo.bind(this);
    this.state = {
      opened: false,
      openModalAfterLogin: false
    };
    // this.offset = null;
  }

  // openModal(closeDD = false) {
  //   const { auth, actionDoLogin, closeDropDown } = this.props;
  //
  //   if (!auth.authenticated) {
  //     this.openComplaintAfterLogin = true;
  //     return actionDoLogin();
  //   }
  //   this.setState({ opened: !this.state.opened },
  //     () => {
  //       if (isBoolean(closeDD) && !closeDD) return false;
  //       if (this.state.opened) {
  //         this.offset = document.body.scrollTop;
  //         document.body.style.top = `${(this.offset / 10) * -1}rem`;
  //         document.body.classList.add('noScroll');
  //       }
  //       if (!this.state.opened && closeDropDown) {
  //         document.body.classList.remove('noScroll');
  //         document.body.scrollTop = this.offset;
  //         this.offset = null;
  //         return closeDropDown();
  //       }
  //     }
  //   );
  // }

  openModalInfo() {
    if (!this.props.auth.authenticated) {
      this.setState({ openModalAfterLogin: true });
      return this.props.actionDoLogin();
    }
    this.setState({ opened: !this.state.opened });
  }

  render() {
    const {
      userPhoto, contentPhoto, userName, className, userId = {}
    } = this.props;

    return (
      <>
        <Button
          {...bemClasses('btn', 'cardInfo', className)}
          title={`Визитная карточка ${userName}`}
          onClick={this.openModalInfo}
          label={userName}
          noPadding
        />
        {this.state.opened &&
          <CardInfoModal
            opened={this.state.opened}
            onClose={this.openModalInfo}
            userPhoto={userPhoto || contentPhoto}
            userName={userName}
            userId={userId}
          />
        }
      </>
    );
  }
}
